module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.17em"
    }
  }, [_vm._v("To my Dad")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.17em"
    }
  }, [_vm._v("Who nightly introduced me to urban fantasy")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.17em"
    }
  }, [_vm._v("Through magic rings that sent and brought back,")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.17em"
    }
  }, [_vm._v("A horse that could talk,")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.17em"
    }
  }, [_vm._v("And a wardrobe that sometimes led between Here and There.")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.17em"
    }
  }, [_vm._v("- Joshua")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 69
// module chunks = 0